import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IdleTimeoutService } from '../idle-timeout.service';

@Component({
    selector: 'app-idle-warning-modal',
    templateUrl: './idle-warning-modal.component.html',
    styleUrls: ['./idle-warning-modal.component.scss'],
    standalone: false
})
export class IdleWarningModalComponent implements OnInit, OnDestroy {
    @Output() stay = new EventEmitter<void>();
    @Output() logout = new EventEmitter<void>();

    remainingSeconds = 0;

    private readonly destroy$ = new Subject<void>();

    constructor(private idleTimeoutService: IdleTimeoutService) {}

    ngOnInit(): void {
        timer(0, 1000)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.updateRemainingSeconds());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    stayLoggedIn(): void {
        this.stay.emit();
    }

    logoutNow(): void {
        this.logout.emit();
    }

    private updateRemainingSeconds(): void {
        this.remainingSeconds = Math.max(
            0,
            Math.ceil(this.idleTimeoutService.getRemainingMs() / 1000)
        );
    }
}
